module.exports = __webpack_public_path__ + "img/light_ic_creation_step2.0a096738.png";